import { useContext } from 'react'

import { InputTextContext } from '../contexts/input-text-context'

export function useInputTextProps() {
  const props = useContext(InputTextContext)
  return props
}
